import { type FC } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { PdpMobileSectionDivider } from '../PdpMobileSectionDivider/PdpMobileSectionDivider';

import styles from './PdpSharedEstimateSimilarSoldSectionLoader.scss';

const PdpSharedEstimateSimilarSoldSectionLoader: FC = () => {
    const { isMobile } = useServerVarsContext();

    if (isMobile) {
        return (
            <>
                <PdpMobileSectionDivider />
                <div className={classnames(dibsCss.pySmall, styles.sectionLoader)}>
                    <div
                        className={classnames(
                            dibsCss.wFull,
                            dibsCss.hFull,
                            dibsCss.roundedXsmall,
                            styles.sectionLoaderContent
                        )}
                    />
                </div>
            </>
        );
    }

    return (
        <div
            className={classnames(
                dibsCss.flex,
                dibsCss.gapLarge,
                dibsCss.pMedium,
                dibsCss.mbLarger,
                dibsCss.border,
                dibsCss.borderSolid,
                dibsCss.borderDolphin,
                dibsCss.roundedXsmall,
                styles.sectionLoader
            )}
        >
            <div
                className={classnames(
                    dibsCss.hFull,
                    dibsCss.roundedXsmall,
                    styles.pricingSectionLoader,
                    styles.sectionLoaderContent
                )}
            />
            <div
                className={classnames(
                    dibsCss.wFull,
                    dibsCss.hFull,
                    dibsCss.roundedXsmall,
                    styles.sectionLoaderContent
                )}
            />
        </div>
    );
};

export default PdpSharedEstimateSimilarSoldSectionLoader;
